import couponQueries from '@apis/queries/couponQueries';
import stampQueries from '@apis/queries/stampQueries';
import StampApi from '@apis/stamp/StampApi';
import { ErrorResponse } from '@models/error';
import { StampCardRow } from '@models/stamp';
import { useActivity } from '@stackflow/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useEffect, useMemo } from 'react';

function useAutoIssueCoupon(cards?: StampCardRow[]) {
    const { isActive } = useActivity();
    const queryClient = useQueryClient();

    const { mutate } = useMutation({
        mutationFn: StampApi.autoIssueCoupons,
        onSuccess({ issuedCouponCount }) {
            if (issuedCouponCount >= 0) {
                queryClient.invalidateQueries({ queryKey: stampQueries.cardList._def });
                queryClient.invalidateQueries({ queryKey: couponQueries._def });
            }
        },
        onError(e: AxiosError<ErrorResponse>) {
            console.error(e);
        },
    });

    const hasAutoIssueCoupon = useMemo(() => {
        if (!isActive || !cards) {
            return false;
        }
        return cards.some((card) => {
            const { stampCount } = card;
            return card.rewardCoupons.some(
                (coupon) => {
                    const { couponIssueType, requiredStampCount } = coupon;
                    return couponIssueType === 'AUTO' && stampCount >= requiredStampCount;
                },
            );
        });
    }, [isActive, cards]);

    useEffect(() => {
        if (hasAutoIssueCoupon) {
            mutate();
        }
    }, [hasAutoIssueCoupon]);
}

export default useAutoIssueCoupon;
